<template>
  <el-dialog title="选择商品" :visible.sync="visible" width="1100px" :before-close="closeCategoryDialog" :close-on-click-modal="false" append-to-body class="goodsDialog">
    <div class="f--c filter">
      <el-cascader placeholder="请选择品类" size="medium" :options="categoryOptions" :props="{ multiple: true, value: 'categoryId', label: 'name', children: 'childList', emitPath: false }" :show-all-levels="false" filterable collapse-tags clearable v-model="categoryValue" @change="selectCategory" style="width:220px;margin-right:20px">
        <template slot-scope="{ node, data }">
          <span>{{ data.name }}</span>
          <span v-if="!node.isLeaf"> ({{ data.childList.length }}) </span>
        </template>
      </el-cascader>
      <!-- <el-select v-model="listParams.lockIng" size="medium" clearable placeholder="上架状态" @change="getProductList" style="width:110px">
        <el-option label="上架" :value="1" />
        <el-option label="下架" :value="2" />
      </el-select>
      <el-select v-model="listParams.lockIng" size="medium" clearable placeholder="是否有库存" @change="getProductList" style="width:120px">
        <el-option label="是" :value="2" />
        <el-option label="否" :value="1" />
      </el-select> -->
      <div>
        <el-select v-model="listParams.searchType" size="medium" style="width:110px" class="rightBorderNone">
          <el-option label="SPU" :value="1" />
          <el-option label="商品名称" :value="2" />
        </el-select>
        <el-popover v-if="+listParams.searchType === 1" placement="bottom" width="400" trigger="click">
          <el-input v-model="listParams.searchNameArrays" size="medium" suffix-icon="el-icon-search" placeholder="支持批量搜索" style="width:300px" clearable @change="getProductList" slot="reference" />
          <el-input v-model="listParams.searchNameArrays" placeholder="支持批量搜索" size="medium" suffix-icon="el-icon-search" type="textarea" style="width:100%" clearable @change="getProductList" :rows="6"></el-input>
        </el-popover>
        <el-input v-if="+listParams.searchType === 2" v-model="listParams.searchNameArrays" size="medium" suffix-icon="el-icon-search" placeholder="输入商品名称" style="width:300px" clearable @change="getProductList" />
      </div>
      <el-checkbox v-model="searchAll">按筛选条件选择全部商品</el-checkbox>
    </div>
    <div>
      <el-table ref="table" v-loading="loading" :data="goodsList" max-height="480" row-key="kkProductId" @selection-change="handleSelectionChange">
        <el-table-column
          :reserve-selection="true"
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column label="商品图片" width="140px">
          <template slot-scope="{row}">
            <el-popover placement="right" width="280" trigger="hover">
              <el-image :src="row.images" fit="cover" />
              <el-image slot="reference" :src="row.images" fit="cover" class="stock-img" />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="产品信息">
          <template slot-scope="{row}">
            <div>{{ row.productName }}</div>
            <div style="color: lightBlue">Item No: {{ row.spuCode }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="virtualStockTotal" label="可用库存" width="150px"></el-table-column>
      </el-table>

      <div class="f-b-c bg-white" style="padding: 12px">
        <div>已选商品个数：{{ addGoods }}</div>
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="listParams.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listParams.pageSize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeCategoryDialog">取 消</el-button>
      <el-button type="primary" @click="affirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
export default {
  data() {
    return {
      listParams: {
        status: 1,
        virtualWarehouseId: 1,
        pageNumber: 1,
        pageSize: 20
      },
      form: {},
      total: 0,
      goodsList: [],
      visible: false,
      loading: false,
      categoryOptions: [],
      categoryValue: [],
      multipleSelection: [],
      searchAll: false
    }
  },
  computed: {
    addGoods() {
      return this.searchAll ? this.total : this.multipleSelection.length
    }
  },
  created() {
    this.$set(this.listParams, 'searchType', 1)
    this.getCategoryList()
    this.getProductList()
  },
  methods:{
    show(form) {
      this.form = _.cloneDeep(form)
      this.visible = true
      this.getProductList()
    },
    closeCategoryDialog() {
      this.$refs.table.clearSelection();
			this.visible = false
      this.listParams = {
        status: 1,
        virtualWarehouseId: 1,
        pageNumber: 1,
        pageSize: 20,
        searchType: 1
      }
      this.categoryValue = []
		},

    affirm() {
      if (!this.addGoods) {
        this.$message.warning('请先选择商品！')
        return
      }
      let param = { ...this.form, insert: this.multipleSelection.map(item => item.kkProductId) }
      if (this.searchAll) {
        delete param.insert
        let params = this.listParams
        params.searchNameArrays = params.searchNameArrays ? params.searchNameArrays.replace(/[；,，;\s\r\n]+/g, ',').split(',') : undefined
        param.params = JSON.stringify(params)
      }
      API.setAlbumModuleProduct(param).then(res => {
        this.closeCategoryDialog()
        this.$emit('getList', res.data.groupId)
        this.$message.success('添加成功')
      })
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    getProductList() {
      this.loading = true
      const params = { ...this.listParams,  }
      params.searchNameArrays = params.searchNameArrays ? params.searchNameArrays.replace(/[；,，;\s\r\n]+/g, ',').split(',') : undefined
      API.promotionGetProductList(params).then(res => {
        if(res.code !== 10000) return this.$message.error(res.message || '获取商品失败')
        this.goodsList = res.data.list
        this.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },


    // 获取品类列表
    async getCategoryList() {
      let { data } = await API.getCategoryList({ pageNumber: 1, pageSize: 1000 })
      if (data && data.list.length) {
        this.deletechildList(data.list)
        this.categoryOptions = data.list
      }
    },
    deletechildList(arr) {
      // 删除最后一级为空的childList字段
      arr.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    },
    // 筛选 - 商品品类级联选择器选中值发生变化时的回调
    selectCategory(value) {
      if (!value.length) {
        this.listParams.categoryIds = undefined
      } else {
        this.listParams.categoryIds = value
      }
      this.getProductList()
    },
  
    pageChange(page) {
      this.listParams.pageNumber = page
      this.getProductList()
    },
    handleSizeChange(size) {
      this.listParams.pageSize = size
      this.pageChange(1)
    },
  }
}
</script>

<style lang="scss" scoped>
.goodsDialog {
  /deep/ .el-dialog__body{
    padding: 10px 20px;
  }

  .stock-img{
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #f5f7fa;
    user-select: none;
    cursor: pointer;
  }
}
.filter{
  >div{
    margin-right: 20px;
  }
}
</style>